module.exports = __webpack_public_path__ + "static/media/example3.b54580b8.jpeg";